export const gap = '20px'
export const inputFieldHeight = '46px'
export const inputBottomGutter = '14px'
export const borderRadius = '4px'
export const marginBottom = `margin-bottom: ${inputBottomGutter}`
